import _ from 'lodash';

import { IColorControlServerMode } from './color-control-server-mode.interface';
import { ColorUtils } from '../color.utils';

export class ColorControlServerHueSaturationMode
  implements IColorControlServerMode {
  public statusPayload = ['CurrentHue', 'CurrentSaturation'];
  public setColorMethod = 'MoveToHueAndSaturation';

  public computateColor = (state: any) => {
    const currentHue: number = <number> _.get(state, 'currentHue');
    const currentSaturation: number = <number> _.get(state, 'currentSaturation');
    if (currentHue != null && currentSaturation != null) {
      const hue = currentHue * 360 / 254;
      const saturation = currentSaturation / 254;
      return ColorUtils.HSVtoRGB(hue, saturation, 1);
    }
    return null;
  };

  public computateColorName = (state: any) => {
    const rgb = this.computateColor(state);
    if (rgb) {
      return ColorUtils.RGBtoColorName(rgb).en;
    }
    return '';
  };

  public buildPayload = (rgb: any) => {
    const { h, s } = ColorUtils.RGBtoHSV(rgb.r, rgb.g, rgb.b);
    return {
      Hue: h * 254 / 360,
      Saturation: s * 254,
      TransitionTime: 50
    };
  };

  public getEffectColor = (params: any) => {
    return this.computateColor({
      currentHue: params.Hue,
      currentSaturation: params.Saturation
    });
  };

  public getEffectColorName = (params: any) => {
    return this.computateColorName({
      currentHue: params.Hue,
      currentSaturation: params.Saturation
    });
  };
}
